/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./CardPrompt.css";
import {
  CardElement,
} from "@stripe/react-stripe-js";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import PropTypes from "prop-types";
import { renderErrorMsg } from "../../assets/component/renderErrorMsg.js";
import errorMsg from "../../assets/json/errMsg.json";
import { simpleFetch } from "../../restWrapper";
import { resolveThemeColors } from "../../assets/helper";
import { Helmet } from "react-helmet";
import checkplusLogo from "../../assets/component/images/checkplus-logo.svg";
import plugLogo from "../../assets/component/images/plug-logo.svg";
import { PLATFORM } from "../../config";

class CardPrompt extends Component {
  constructor(props) {
    super(props);
    try {
      if (
        this.props.location.state === null ||
        this.props.location.state === undefined
      ) {
        this.props.history.push("/SelectMission");
      }

      this.state = {
        ...this.props.location.state,
        ...{
          language: "zh",
          payerInfo: {
            payerName: "",
            payerEmail: "",
            payerPhone: "",
          },
        },
      };
    } catch (e) {
      this.props.history.push("/SelectMission");
    }

    this.state.payerInfo.payerName =
      this.state.donorInfo && this.state.donorInfo.firstName && this.state.donorInfo.lastName
        ? this.state.donorInfo.firstName + " " + this.state.donorInfo.lastName
        : "";

    this.state.payerInfo.payerEmail = (this.state.donorInfo && this.state.donorInfo.email) || "";
    this.state.payerInfo.payerPhone = (this.state.donorInfo && this.state.donorInfo.phoneNumber) || "";

    this.handlePayerName = this.setPayerInfoData.bind(this, "payerName");
    this.handlePayerEmail = this.setPayerInfoData.bind(this, "payerEmail");
    this.handlePayerPhone = this.setPayerInfoData.bind(this, "payerPhone");

    this.onBackBtnClicked = this.onBackBtnClicked.bind(this);
    this.onNextBtnClicked = this.onNextBtnClicked.bind(this);
  }

  setPayerInfoData(name, e) {
    let data = this.state.payerInfo;
    data[name] = e.target.value;
    let err = this.state.errorMsg;
    this.setState({
      errorMsg: err,
      payerInfo: data,
    });
  }

  setCardData(name, s) {
    let data = this.state.card;
    data[name] = s.split(" ").join("");
    this.setState({
      card: data,
    });
  }

  onBackBtnClicked() {
    this.props.history.push({
      pathname: "/SelectPayment",
      state: this.props.location.state,
    });
  }

  onNextBtnClicked(ev) {

    ev.preventDefault();

    const isConfirm = window.confirm(this.props.languageObj.confirmBtn + "?");
    if (!isConfirm) return null;

    if (this.props.stripe) {
      // Use Elements to get a reference to the Card Element mounted somewhere
      // in your <Elements> tree. Elements will know how to find your Card Element
      // because only one is allowed.
      // See our getElement documentation for more:
      // https://stripe.com/docs/stripe-js/reference#elements-get-element

      const cardElement = this.props.elements.getElement("card");


      // From here we can call createPaymentMethod to create a PaymentMethod
      // See our createPaymentMethod documentation for more:
      // https://stripe.com/docs/stripe-js/reference#stripe-create-payment-method

      this.props.stripe
        .createPaymentMethod({
          type: "card",
          card: cardElement,
          billing_details: {
            name: this.state.payerInfo.payerName,
            email: this.state.payerInfo.payerEmail,
            phone: this.state.payerInfo.payerPhone,
          },
        })

        .then(({ paymentMethod }) => {
          let err = errorMsg[this.props.language].paymentErr.cardInfo;

          if (!paymentMethod) {
            this.setState({
              err: err,
            });
            return null;
          } else {
            let dataObj = this.state;
            dataObj.paymentMethod = paymentMethod.id;
            dataObj.brand = paymentMethod.card.brand;
            dataObj.last4 = paymentMethod.card.last4;
            // Capture card issuing country for accurate fee calculation
            dataObj.cardCountry = paymentMethod.card.country;
            this.props.history.push({
              pathname: "/Review",
              state: dataObj,
            });
          }

          if (this.props.isAuth) {
            simpleFetch("/cards", "POST", {
              paymentMethod: paymentMethod.id,
            }).then((res) => {
              if (res.status !== 200) {
                const err = res.body.message;
                this.setState({
                  err: err,
                });
                return null;
              }
              let dataObj = this.state;
              dataObj.cardId = res.body.id;
              dataObj.brand = res.body.brand;
              // Capture card issuing country for authenticated users too
              dataObj.cardCountry = paymentMethod.card.country;

              this.props.history.push({
                pathname: "/Review",
                state: dataObj,
              });
            });
          } else {
            let data = this.state;

            data.paymentMethod = paymentMethod.id;

            data.brand = paymentMethod.card.brand;
            // Ensure transaction type is preserved
            data.transactionType = data.transactionType || 'donation';
            this.props.history.push({ pathname: "/Review", state: data });
          }
        });
    } else {
      let err = errorMsg[this.props.language].fail;
      this.setState({
        err: err,
      });
    } 
  }

  errRender(testid) {
    return <div data-testid={testid}>{renderErrorMsg(this.state.err)}</div>;
  }

  render() {

    if (
      this.props.location.state === null ||
      this.props.location.state === undefined
    ) {
      return <this.props.RenderFullPageLoading />;
    }

    const orgHeaderColor = (this.state.organization && this.state.organization.headerColor) || "000000";
    const orgButtonColor = (this.state.organization && this.state.organization.buttonColor) || "ffffff";
    const resolved = resolveThemeColors(orgHeaderColor, orgButtonColor);

    const bgStyle = {
      background: "#" + orgHeaderColor,
    };

    const nextBtnStyle = {
      background: "#" + resolved.headerColor,
      color: "#" + resolved.buttonColor,
    };

    const languageObj = this.props.languageObj;

    // Check if this is a free plan flow
    const isFreePlanFlow =
      this.state.isFreePlanFlow ||
      (this.state.organization && this.state.organization.currentPlan === "free");

    // Set class names based on flow type
    const viewClassName = isFreePlanFlow ? "CardPrompt-view CardPrompt-view--free" : "CardPrompt-view";
    const headerClassName = "CardPrompt-header";
    const mainClassName = isFreePlanFlow ? "CardPrompt-main CardPrompt-main--free" : "CardPrompt-main";
    const ccContainerClassName = isFreePlanFlow ? "CardPrompt-ccContainer CardPrompt-ccContainer--free" : "CardPrompt-ccContainer";
    const backContainerClassName = isFreePlanFlow ? "CardPrompt-backContainer CardPrompt-backContainer--free" : "CardPrompt-backContainer";
    const confirmBtnClassName = isFreePlanFlow ? "CardPrompt-confirmBtn CardPrompt-confirmBtn--free" : "CardPrompt-confirmBtn";

    const renderHeader = () => {
      if (isFreePlanFlow) {
        return (
          <div className={headerClassName}>
            <div className="CardPrompt-freeBrand">
              <span className="CardPrompt-freeBrandPowered">Powered by</span>
              <img
                src={PLATFORM === "plug" ? plugLogo : checkplusLogo}
                alt={PLATFORM === "plug" ? "Plug" : "CheckPlus for Nonprofits"}
                className="CardPrompt-freeBrandLogoImage"
              />
            </div>
            <div className="CardPrompt-freeHeaderNote">
              {languageObj.secureCheckout || "Secure Checkout"}
            </div>
          </div>
        );
      }
      return null;
    };

    return (
      <div className={viewClassName}>
        <Helmet>
          <title>{this.state.organization.organizationName}</title>
        </Helmet>

        {isFreePlanFlow && renderHeader()}
        {!isFreePlanFlow && <div className="CardPrompt-bg" style={bgStyle} />}

        <div className={mainClassName}>
          <div className={ccContainerClassName}>
            <div
              className={backContainerClassName}
              data-testid="cardprompt-back-button"
              onClick={this.onBackBtnClicked}
            >
              <div className="CardPrompt-back">
                <div className="CardPrompt-backBtn" />
                <div className="CardPrompt-backText">
                  {languageObj.backText}
                </div>
              </div>
            </div>

            <div className="CardPrompt-paymentNetworks" />

            <div>
              <div className="CardPrompt-subheading">
                {languageObj.cardholderName || "Cardholder Name"}
              </div>

              <div className="CardPrompt-inputFieldContainer">
                <input
                  className="CardPrompt-inputField"
                  data-testid="cardprompt-payer-name-input"
                  value={this.state.payerInfo.payerName}
                  onChange={this.handlePayerName}
                  style={{ base: { fontSize: "18px" } }}
                />
              </div>

              <div className="CardPrompt-subheading">
                {languageObj.emailAddress || "Email Address"}
              </div>

              <div className="CardPrompt-inputFieldContainer">
                <input
                  className="CardPrompt-inputField"
                  data-testid="cardprompt-payer-email-input"
                  value={this.state.payerInfo.payerEmail}
                  onChange={this.handlePayerEmail}
                  style={{ base: { fontSize: "18px" } }}
                />
              </div>

              <div className="CardPrompt-subheading">
                {languageObj.phone || "Phone"}
              </div>

              <div className="CardPrompt-inputFieldContainer">
                <input
                  className="CardPrompt-inputField"
                  data-testid="cardprompt-payer-phone-input"
                  country={"HK"}
                  value={this.state.payerInfo.payerPhone}
                  onChange={this.handlePayerPhone}
                  style={{ base: { fontSize: "18px" } }}
                />
              </div>

              <div className="CardPrompt-subheading">
                {languageObj.subheading[0]}
              </div>

              <div className="CardPrompt-inputFieldContainer">
                <CardElement className="CardPrompt-cardElement" />
              </div>
            </div>

            <div className="CardPrompt-lockContainer">
              <div className="CardPrompt-lock"></div>
              <div className="CardPrompt-lockText">{languageObj.lock}</div>
            </div>

            <div className="CardPrompt-stripeContainer">
              <div className="CardPrompt-stripe"></div>
              <div className="CardPrompt-stripeText">
                {languageObj.stripe[0]}
                <br />
                {languageObj.stripe[1]}
              </div>
            </div>
            {this.errRender("cardprompt-submit-error")}

            <div
              className={confirmBtnClassName}
              data-testid="cardprompt-next-button"
              style={isFreePlanFlow ? {} : nextBtnStyle}
              onClick={this.onNextBtnClicked}
            >
              {languageObj.confirmBtn}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
CardPrompt.propTypes = {
  stripe: PropTypes.object.isRequired,
  language: PropTypes.string,
  languageObj: PropTypes.object,
  isAuth: PropTypes.bool,
  elements : PropTypes.object,
};

// Wrapper component to use Stripe hooks with class component
function CardPromptWithStripe(props) {
  const stripe = useStripe();
  const elements = useElements();

  return <CardPrompt {...props} stripe={stripe} elements={elements} />;
}

export default CardPromptWithStripe;
